import React, { useEffect, useContext, useState } from 'react';
import slugify from 'slugify';
import { formatMoney } from "@shopify/theme-currency";
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Scrollbar } from 'swiper';
import { VariantOptionsForm } from './'

// Styles must use direct files imports
import 'swiper/modules/scrollbar/scrollbar.scss';

export const BundleCardMerged = ({ object }) => {
  const { products } = object;
  const [selectedProduct, setSelectedProduct] = useState(products[0])
  const [selectedVariant, setSelectedVariant] = useState(selectedProduct.variants.find(v => v.available) ? selectedProduct.variants.find(v => v.available) : selectedProduct.variants[0])
  const [selectedOptions, setSelectedOptions] = useState(selectedProduct.options.reduce((o, key) => ({ ...o, [key]: selectedVariant.options[selectedProduct.options.indexOf(key)] }), {}))

  useEffect(() => {
    setSelectedVariant(selectedProduct.variants.find(v => Object.values(selectedOptions).every(r => v.options.includes(r))))
  }, [selectedOptions])

  const handleProductChange = (e) => {
    const newProduct = products.find(p => p.handle == e.target.value)
    setSelectedProduct(newProduct)
    setSelectedVariant(newProduct.variants.find(v => v.available) ? newProduct.variants.find(v => v.available) : newProduct.variants[0])
  }

  const handleVariantChange = (e) => {
    setSelectedOptions({
      ...selectedOptions,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div className="Card Card--product">
      <figure className='Card__figure'>
        {selectedProduct.featured_image &&
          <img
            src={`${selectedProduct.featured_image}&width=200`}
            srcSet={`${selectedProduct.featured_image}&width=200 200w,${selectedProduct.featured_image}&width=400 400w,${selectedProduct.featured_image}&width=600 600w`}
            loading="lazy"
            alt={object.title}
          />
        }
      </figure>
      <div className='Card__details'>
        <h4 className='Card__title'>{selectedProduct.title}</h4>
        {selectedVariant &&
          <div className='price'>{formatMoney(selectedVariant.price, theme.moneyFormat)}</div>
        }
        <div className='product-selector'>
          <header>Color</header>
          <form onChange={handleProductChange} >
            <Swiper
              slidesPerView={"auto"}
              modules={[Scrollbar]}
              scrollbar={{ draggable: true }}
              spaceBetween={8}
            >
              {products.map(p =>
                <SwiperSlide key={p.id}>
                  <div className='product-swatch-container'>
                    <label>
                      <span className="u-hidden">{p.title.split('-')[0]}</span>
                      <input type="radio" name="product" key={p.handle} value={p.handle} checked={p.id == selectedProduct.id ? true : false}></input>
                      <figure>
                        <img src={window.__webpack_public_path__ + slugify(p.title.replace(/[.+&™/]/g, ' '), { lower: true }) + '.png'} />
                      </figure>
                    </label>
                  </div>
                </SwiperSlide>
              )}
            </Swiper>
          </form>
        </div>
        <VariantOptionsForm
          object={selectedProduct}
          selectedVariant={selectedVariant}
          options={selectedProduct.options}
          variants={selectedProduct.variants}
          handleChange={handleVariantChange}
        />
      </div >
    </div >
  )
}